// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-journal-entry-container {
  background: transparent;
  border-radius: 0;
  padding: 30px;
  box-shadow: none;
  margin-top: 0;
}

.create-journal-entry-container h2 {
  color: #333;
  margin-bottom: 25px;
  font-size: 1.8rem;
}

.journal-entry-form {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.form-header {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-weight: 600;
  color: #333;
  font-size: 0.95rem;
}

.form-group input,
.form-group select {
  padding: 12px 15px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.lines-section {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.lines-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.lines-header h3 {
  margin: 0;
  color: #333;
  font-size: 1.3rem;
}

.lines-table {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.table-header {
  display: grid;
  grid-template-columns: 2fr 2fr 1fr 1fr 80px;
  gap: 10px;
  padding: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: bold;
  font-size: 0.95rem;
}

.table-row {
  display: grid;
  grid-template-columns: 2fr 2fr 1fr 1fr 80px;
  gap: 10px;
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
  align-items: center;
}

.table-row:last-child {
  border-bottom: none;
}

.table-row:hover {
  background-color: #f8f9fa;
}

.col-account select,
.col-description input,
.col-amount input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 0.95rem;
}

.col-amount input {
  text-align: right;
  font-family: 'Courier New', monospace;
}

.col-action {
  display: flex;
  justify-content: center;
}

.btn-sm {
  padding: 6px 12px;
  font-size: 0.85rem;
}

.totals-row {
  margin-top: 20px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  border: 2px solid #667eea;
}

.totals-label {
  font-weight: bold;
  color: #333;
  font-size: 1.1rem;
  margin-bottom: 10px;
}

.totals-values {
  display: flex;
  gap: 30px;
  align-items: center;
  flex-wrap: wrap;
}

.total-debit,
.total-credit {
  font-size: 1.2rem;
  font-weight: bold;
  font-family: 'Courier New', monospace;
  color: #333;
}

.total-debit.unbalanced,
.total-credit.unbalanced {
  color: #dc3545;
}

.balance-status {
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 0.95rem;
}

.balance-status.balanced {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  color: white;
}

.balance-status.unbalanced {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  color: white;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding-top: 20px;
  border-top: 2px solid #e0e0e0;
}

.error-message {
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  color: #c33;
  display: flex;
  align-items: center;
  gap: 10px;
}

.error-icon {
  font-size: 1.5rem;
}

.success-message {
  background: #efe;
  border: 1px solid #cfc;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  color: #3c3;
  display: flex;
  align-items: center;
  gap: 10px;
}

.success-icon {
  font-size: 1.5rem;
}

@media (max-width: 768px) {
  .form-header {
    grid-template-columns: 1fr;
  }

  .table-header,
  .table-row {
    grid-template-columns: 1fr;
    gap: 5px;
  }

  .col-account,
  .col-description,
  .col-amount,
  .col-action {
    width: 100%;
  }

  .table-header div::before {
    content: attr(data-label);
    font-weight: bold;
    display: block;
    margin-bottom: 5px;
  }

  .totals-values {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CreateJournalEntry.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,qCAAqC;EACrC,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;AACF","sourcesContent":[".create-journal-entry-container {\n  background: transparent;\n  border-radius: 0;\n  padding: 30px;\n  box-shadow: none;\n  margin-top: 0;\n}\n\n.create-journal-entry-container h2 {\n  color: #333;\n  margin-bottom: 25px;\n  font-size: 1.8rem;\n}\n\n.journal-entry-form {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.form-header {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-group label {\n  font-weight: 600;\n  color: #333;\n  font-size: 0.95rem;\n}\n\n.form-group input,\n.form-group select {\n  padding: 12px 15px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.3s;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.lines-section {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 8px;\n}\n\n.lines-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.lines-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 1.3rem;\n}\n\n.lines-table {\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #e0e0e0;\n}\n\n.table-header {\n  display: grid;\n  grid-template-columns: 2fr 2fr 1fr 1fr 80px;\n  gap: 10px;\n  padding: 15px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  font-weight: bold;\n  font-size: 0.95rem;\n}\n\n.table-row {\n  display: grid;\n  grid-template-columns: 2fr 2fr 1fr 1fr 80px;\n  gap: 10px;\n  padding: 15px;\n  border-bottom: 1px solid #e0e0e0;\n  align-items: center;\n}\n\n.table-row:last-child {\n  border-bottom: none;\n}\n\n.table-row:hover {\n  background-color: #f8f9fa;\n}\n\n.col-account select,\n.col-description input,\n.col-amount input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 0.95rem;\n}\n\n.col-amount input {\n  text-align: right;\n  font-family: 'Courier New', monospace;\n}\n\n.col-action {\n  display: flex;\n  justify-content: center;\n}\n\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 0.85rem;\n}\n\n.totals-row {\n  margin-top: 20px;\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  border: 2px solid #667eea;\n}\n\n.totals-label {\n  font-weight: bold;\n  color: #333;\n  font-size: 1.1rem;\n  margin-bottom: 10px;\n}\n\n.totals-values {\n  display: flex;\n  gap: 30px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.total-debit,\n.total-credit {\n  font-size: 1.2rem;\n  font-weight: bold;\n  font-family: 'Courier New', monospace;\n  color: #333;\n}\n\n.total-debit.unbalanced,\n.total-credit.unbalanced {\n  color: #dc3545;\n}\n\n.balance-status {\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-weight: bold;\n  font-size: 0.95rem;\n}\n\n.balance-status.balanced {\n  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);\n  color: white;\n}\n\n.balance-status.unbalanced {\n  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);\n  color: white;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  padding-top: 20px;\n  border-top: 2px solid #e0e0e0;\n}\n\n.error-message {\n  background: #fee;\n  border: 1px solid #fcc;\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 20px;\n  color: #c33;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.error-icon {\n  font-size: 1.5rem;\n}\n\n.success-message {\n  background: #efe;\n  border: 1px solid #cfc;\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 20px;\n  color: #3c3;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.success-icon {\n  font-size: 1.5rem;\n}\n\n@media (max-width: 768px) {\n  .form-header {\n    grid-template-columns: 1fr;\n  }\n\n  .table-header,\n  .table-row {\n    grid-template-columns: 1fr;\n    gap: 5px;\n  }\n\n  .col-account,\n  .col-description,\n  .col-amount,\n  .col-action {\n    width: 100%;\n  }\n\n  .table-header div::before {\n    content: attr(data-label);\n    font-weight: bold;\n    display: block;\n    margin-bottom: 5px;\n  }\n\n  .totals-values {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
